import { Injectable } from '@angular/core';

import { Resource, ResourceService } from './resource';

export class PhotoComment extends Resource {
  comment: string;
  commenterId: number;
  commenterType: string;
  attendancePhotoId: number;
}

@Injectable({ providedIn: 'root' })
export class PhotoComments extends ResourceService<PhotoComment> {
  constructor() {
    super();

    this.base = 'photo_comments';
    this.ctor = PhotoComment;
  }
}
